module.exports = __webpack_public_path__ + "static/media/mpcourier.cf975d70.png";